module.exports = __webpack_public_path__ + "static/img/admin.2449f88e.svg";